module.exports = __webpack_public_path__ + "static/media/31JFA10.7d5fcad4.jpg";